import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=8fd6c924&scoped=true&"
import script from "./Criteria.vue?vue&type=script&lang=js&"
export * from "./Criteria.vue?vue&type=script&lang=js&"
import style0 from "./Criteria.vue?vue&type=style&index=0&id=8fd6c924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6c924",
  null
  
)

export default component.exports